import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const heroScreenSearchBarStyles = (theme: Theme) => ({
	root: {
		borderRadius: '100px',
		background: 'white',
		minHeight: { xs: '50px', lg: '78px' },
		width: { lg: '574px', sm: '574px', s: '400px', xs: '90%' },
		outlineColor: '#E7E7E7',
		outlineStyle: 'solid',
		outlineOffset: '-3px',
		outlineWidth: '3px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: { xs: '10px', md: '18px', lg: '24px' },
		p: { xs: '6px 18px', lg: '10px 24px' },
	},
	inputSection: { flexGrow: '1', py: '4px', display: 'flex', alignItems: 'center' },
	textField: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: '500',
		color: Colors['120E0D'],

		flexGrow: '1',
		'& .MuiInputBase-root::before': {
			borderBottom: 'none !important',
			content: 'none',
		},
		'& .MuiInputBase-root::after': {
			borderBottom: 'none !important',
			content: 'none',
		},

		'& .MuiInputBase-input': {
			fontFamily: 'Montserrat',
			fontWeight: '500',
			fontSize: '16px',
			color: Colors['120E0D'],
		},

		'& .MuiInputBase-input::placeholder': {
			opacity: 1,
			fontFamily: 'Montserrat',
			fontWeight: '500',
			fontSize: '16px',
			color: Colors['120E0D'],
		},
	},
	inputAdornment: { mr: '16px' },
	textFieldIcon: {
		display: 'flex',
		alignItems: 'center',
		color: 'grey',
	},
	separator: {
		width: '2px',
		height: '100%',
		background: '#E7E7E7',
	},
	selectSection: { py: '4px', minWidth: { xs: '110px', sm: '170px' } },
	selectLabel: { fontFamily: 'Montserrat', fontSize: '16px', fontWeight: '500', color: Colors['120E0D'] },
	selectItem: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: '500',
		color: Colors['120E0D'],
	},
	selectFormControll: {
		'& .MuiSelect-select': {
			fontFamily: 'Montserrat',
			fontSize: '16px',
			fontWeight: '500',
			color: Colors['120E0D'],
		},

		'& .MuiInputBase-root': {
			background: 'white',
		},

		'& .MuiFilledInput-root': {
			'&::before': {
				content: '""',
				borderBottom: 'none !important',
			},
			'&::after': {
				content: '""',
				borderBottom: 'none !important',
			},
		},
	},
});
